import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import ContextModal, { CONTEXT_MODAL_AUTO_WIDTH } from '../context-modal';
import OutsideClickHandler from '../../helpers/hoc/close/outside-click-handler';
import { getContextCoords } from '../../helpers/utils';
import InstructionHubMessage, {
  INSTRUCTION_HUB_MESSAGE_CONTEXTS
} from '../instruction-hub-message';
import { INSTRUCTION_HUB_DIALOG_WIDTH } from '../instruction-hub-message/styled';
import DialogLayer from './styled';

const FEEDBACK_DIALOG_ID = 'instructionHubFeedback';

const InstructionHubFeedback = ({ i18n, context, isBlocked, children }) => {
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({
    posX: 0,
    posY: 0,
    posArrow: 0,
    reverseArrow: false
  });
  const isDialogOpen = isBlocked && isOpen;

  useEffect(() => {
    if (!isDialogOpen) {
      return undefined;
    }

    const close = () => setIsOpen(false);
    window.addEventListener('scroll', close, true);

    return () => window.removeEventListener('scroll', close, true);
  }, [isDialogOpen]);

  if (!isBlocked) {
    return children;
  }

  const handleTriggerClick = (event) => {
    event.stopPropagation();
    setPosition(
      getContextCoords(
        triggerRef.current.getBoundingClientRect(),
        INSTRUCTION_HUB_DIALOG_WIDTH
      )
    );
    setIsOpen(!isDialogOpen);
  };

  return (
    <OutsideClickHandler
      callback={() => setIsOpen(false)}
      forButton={FEEDBACK_DIALOG_ID}
    >
      <div
        ref={triggerRef}
        data-testid="instruction-hub-feedback-trigger"
        onClickCapture={handleTriggerClick}
      >
        {children}
      </div>
      {isDialogOpen &&
        createPortal(
          // The id matches forButton so clicks inside the portal are not outside clicks.
          <DialogLayer id={FEEDBACK_DIALOG_ID}>
            <ContextModal
              show
              contextTheme="instructionHub"
              modalWidth={CONTEXT_MODAL_AUTO_WIDTH}
              flowUp={position.reverseArrow}
              positionArrow={position.posArrow}
              positionX={position.posX}
              positionY={position.posY}
            >
              <InstructionHubMessage
                i18n={i18n}
                context={context}
                onOpen={() => setIsOpen(false)}
              />
            </ContextModal>
          </DialogLayer>,
          document.body
        )}
    </OutsideClickHandler>
  );
};

InstructionHubFeedback.propTypes = {
  i18n: PropTypes.object.isRequired,
  context: PropTypes.oneOf(Object.values(INSTRUCTION_HUB_MESSAGE_CONTEXTS))
    .isRequired,
  isBlocked: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default InstructionHubFeedback;



// WEBPACK FOOTER //
// ./components/instruction-hub-feedback/index.js